/* Localize widget controls only; preserve review text, authors and ratings. */
(() => {
  const labels = new Map([
    ['Write a review', 'レビューを書く'], ['All', 'すべて'],
    ['With images', '写真あり'], ['Without images', '写真なし']
  ]);
  function translate(value) {
    const text = value.trim();
    if (labels.has(text)) return value.replace(text, labels.get(text));
    if (/^\d+ Reviews?$/.test(text)) return value.replace(text, 'レビュー ' + text.match(/^\d+/)[0] + '件');
    if (/^[1-5] Stars?$/.test(text)) return value.replace(text, '星' + text[0]);
    return value;
  }
  function localize(root) {
    root.querySelectorAll('button, option, .tw-opacity-70').forEach(el => {
      if (el.childElementCount === 0) {
        const next = translate(el.textContent);
        if (next !== el.textContent) el.textContent = next;
        return;
      }
      for (const node of el.childNodes) {
        if (node.nodeType !== Node.TEXT_NODE) continue;
        const next = translate(node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    });
    root.querySelectorAll('[alt], [aria-label]').forEach(el => {
      for (const attr of ['alt', 'aria-label']) {
        const value = el.getAttribute(attr);
        if (value && /^Foto \d+$/.test(value)) el.setAttribute(attr, value.replace('Foto ', 'レビュー写真 '));
      }
    });
  }
  const watched = new WeakSet();
  function mount() {
    document.querySelectorAll('[id*="bk_reviews_bk_reviews_review_section"]').forEach(root => {
      if (watched.has(root)) return;
      watched.add(root);
      localize(root);
      new MutationObserver(() => localize(root)).observe(root, {childList:true, subtree:true, characterData:true});
    });
  }
  mount();
  new MutationObserver(mount).observe(document.body, {childList:true, subtree:true});
})();
